import { ReactComponent as ArrowIcon } from './arrow-icon.svg'
export default ArrowIcon
